import { RJSFSchema } from "shared/types/RJSF"

export function filterFieldsWithSingleChoice(schema: RJSFSchema) {
  return !!schema.enum && schema.enum.length === 1 && !schema.error
}
